import {
  ORDER_DELIVERY_METHOD,
  OrderDeliveryMethod,
  STATUS_LABEL,
  StatusLabel,
} from "../../common/constants/order-display.constants";
import { LCR_DELIVERY_METHOD, LCR_STATUS, LcrStatus } from "./lcr-order.types";
import { DeliveryMethod, ITO_ORDER_STATUS, ItoOrderStatus } from "./orders.types";

export const orderDeliveryMethodFor = (deliveryMethod: DeliveryMethod): OrderDeliveryMethod =>
  deliveryMethod === LCR_DELIVERY_METHOD.shipToHome
    ? ORDER_DELIVERY_METHOD.ship
    : ORDER_DELIVERY_METHOD.pickup;

/** ITO creates the order before the page can load it, so no ITO status maps to placing. */
const STATUS_LABEL_BY_ITO_STATUS: Record<ItoOrderStatus, StatusLabel> = {
  [ITO_ORDER_STATUS.new]: STATUS_LABEL.created,
  [ITO_ORDER_STATUS.processing]: STATUS_LABEL.processing,
  [ITO_ORDER_STATUS.pendingApproval]: STATUS_LABEL.processing,
  [ITO_ORDER_STATUS.approved]: STATUS_LABEL.processing,
  [ITO_ORDER_STATUS.pendingShipping]: STATUS_LABEL.processing,
  [ITO_ORDER_STATUS.shipped]: STATUS_LABEL.shipped,
  [ITO_ORDER_STATUS.delivered]: STATUS_LABEL.delivered,
  [ITO_ORDER_STATUS.rejected]: STATUS_LABEL.rejected,
  [ITO_ORDER_STATUS.cancelled]: STATUS_LABEL.cancelled,
};

/** Undefined only for a value outside ITO's status contract (REQ-008). */
export const itoStatusLabelFor = (status: string | undefined): StatusLabel | undefined =>
  STATUS_LABEL_BY_ITO_STATUS[status?.toUpperCase() as ItoOrderStatus];

const SHARED_LCR_STATUS_LABELS = {
  [LCR_STATUS.accepted]: STATUS_LABEL.placing,
  [LCR_STATUS.processing]: STATUS_LABEL.processing,
  [LCR_STATUS.paused]: STATUS_LABEL.processing,
  [LCR_STATUS.error]: STATUS_LABEL.creationFailed,
  [LCR_STATUS.cancelled]: STATUS_LABEL.cancelled,
  [LCR_STATUS.processingIssue]: STATUS_LABEL.problem,
};

const SHIP_LCR_STATUS_LABELS: Record<LcrStatus, StatusLabel> = {
  ...SHARED_LCR_STATUS_LABELS,
  [LCR_STATUS.shipped]: STATUS_LABEL.shipped,
  [LCR_STATUS.pendingPickup]: STATUS_LABEL.shipped,
  [LCR_STATUS.delivered]: STATUS_LABEL.delivered,
};

/** A pickup order has no Shipped step, so a shipped order is still being processed until it is ready for pickup. */
const PICKUP_LCR_STATUS_LABELS: Record<LcrStatus, StatusLabel> = {
  ...SHARED_LCR_STATUS_LABELS,
  [LCR_STATUS.shipped]: STATUS_LABEL.processing,
  [LCR_STATUS.pendingPickup]: STATUS_LABEL.readyForPickup,
  [LCR_STATUS.delivered]: STATUS_LABEL.pickedUp,
};

/** Undefined only for a value outside the LCR status contract (REQ-008). */
export const lcrStatusLabelFor = (
  status: LcrStatus,
  deliveryMethod: DeliveryMethod
): StatusLabel | undefined =>
  (orderDeliveryMethodFor(deliveryMethod) === ORDER_DELIVERY_METHOD.pickup
    ? PICKUP_LCR_STATUS_LABELS
    : SHIP_LCR_STATUS_LABELS)[status];
